import packageJson from '../../package.json';


export const environment = {
  production: false,
  appVersion: packageJson.version + '-dev',
  ngVersion: (packageJson as any).ngVersion,
  GOOGLE_MAPS_API_KEY: 'AIzaSyDpgQMpcfx1QU-8SM-ljcgjG4xrYtIYby4',
};
